export const startWebSettings = () => {
    // Bloquear zoom táctil
    document.addEventListener('touchstart', function(e) {
        if (e.touches.length > 1) {
            e.preventDefault();
        }
    }, { passive: false });

    document.addEventListener('gesturestart', function(e) {
        e.preventDefault();
    }, { passive: false });

    // Bloquear zoom con rueda del ratón
    window.addEventListener('wheel', (e) => {
        if (e.ctrlKey || e.metaKey) {
            e.preventDefault();
        }
    }, { passive: false });

    // Bloquear menú contextual (clic derecho)
    window.addEventListener('contextmenu', function(e) {
        e.preventDefault();
    }, false);

    // Bloquear todos los atajos de teclado
    window.addEventListener('keydown', function(e) {
        const key = e.key.toLowerCase();

        // Bloquear todas las teclas de función (F1-F12)
        if (e.key.startsWith('F') && e.key.length > 1) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        // Bloquear zoom con teclado
        if ((e.ctrlKey || e.metaKey) && ['+', '-', '=', '_'].includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        // Bloquear Ctrl + Shift + combinaciones
        if ((e.ctrlKey || e.metaKey) && e.shiftKey) {
            const shiftForbidden = ['i', 'j', 'c', 'n', 't'];
            if (shiftForbidden.includes(key)) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
        }

        // Bloquear Ctrl + tecla
        if (e.ctrlKey || e.metaKey) {
            const forbidden = [
                'p', // Imprimir
                'u', // Ver código fuente
                's', // Guardar
                'j', // Descargas
                'k', // Búsqueda
                'r', // Recargar
                'n', // Nueva ventana
                't', // Nueva pestaña
                'f', // Buscar en página
                'd', // Marcadores
                'w', // Cerrar pestaña
            ];
            if (forbidden.includes(key)) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
        }
    }, true);
};
